import { Typography } from 'antd'
import styled from 'styled-components'

const { Text: AntText } = Typography

export const Text = styled(AntText)`
  font-weight: 700;
`
